import React, { useState, useEffect } from 'react';
import { db, auth } from '../firebase'; // auth EKLENDİ
import { doc, serverTimestamp, writeBatch, collection, query, where, getDocs } from 'firebase/firestore';
import Modal from './Modal'; 
import CurrencyInput from './CurrencyInput'; 
// YENİ: Loglama
import { logIslem } from '../utils/logger';

function CariDuzenleModal({ show, onClose, cariData, taksitData }) {
  const [firmaSahis, setFirmaSahis] = useState('');
  const [tc, setTc] = useState('');
  const [adSoyad, setAdSoyad] = useState('');
  const [telefon, setTelefon] = useState('');
  const [adres, setAdres] = useState('');
  
  const [yapilandir, setYapilandir] = useState(false); 
  const [yeniToplamBorc, setYeniToplamBorc] = useState(''); 
  const [yeniTaksitSayisi, setYeniTaksitSayisi] = useState('0');
  const [baslangicTarihi, setBaslangicTarihi] = useState(new Date().toISOString().split('T')[0]);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (cariData) {
      setFirmaSahis(cariData.firmaSahis || '');
      setTc(cariData.tc || '');
      setAdSoyad(cariData.adSoyad || '');
      setTelefon(cariData.telefon || '');
      setAdres(cariData.adres || '');
      const mevcutBorc = taksitData ? taksitData.reduce((acc, t) => acc + t.miktar, 0) : 0;
      setYeniToplamBorc(mevcutBorc);
      setYeniTaksitSayisi(taksitData ? taksitData.length : 0);
    }
  }, [cariData, taksitData]);

  const handleSave = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    const userEmail = auth.currentUser ? auth.currentUser.email : "Bilinmeyen";

    try {
      const batch = writeBatch(db);
      const cariRef = doc(db, 'cariler', cariData.id);

      batch.update(cariRef, {
        firmaSahis, tc, adSoyad, telefon, adres, updatedAt: serverTimestamp()
      });

      // İsim Güncelleme Kontrolü
      const yeniIsim = cariData.cariTipi === 'Tedarikçi' ? firmaSahis : adSoyad;
      const eskiIsim = cariData.cariTipi === 'Tedarikçi' ? cariData.firmaSahis : cariData.adSoyad;
      if (yeniIsim !== eskiIsim) {
          const collectionName = cariData.cariTipi === 'Tedarikçi' ? 'odemeler' : 'taksitler';
          const nameField = cariData.cariTipi === 'Tedarikçi' ? 'firmaSahis' : 'cariAd';
          const q = query(collection(db, collectionName), where("cariId", "==", cariData.id));
          const querySnapshot = await getDocs(q);
          querySnapshot.forEach((docSnap) => {
              const docRef = doc(db, collectionName, docSnap.id);
              batch.update(docRef, { [nameField]: yeniIsim });
          });
      }

      let logDetay = `Cari Güncelleme: ${yeniIsim}`;

      // Finansal Yapılandırma
      if (yapilandir) {
        const borc = parseFloat(yeniToplamBorc);
        const taksit = parseInt(yeniTaksitSayisi, 10);
        const isTedarikci = cariData.cariTipi === 'Tedarikçi';
        const collectionName = isTedarikci ? 'odemeler' : 'taksitler';

        if (borc > 0) {
           if (taksitData && taksitData.length > 0) {
             taksitData.forEach(t => {
               const ref = doc(db, collectionName, t.id);
               batch.delete(ref);
             });
           }

           if (taksit > 0) {
               const aylikTutar = borc / taksit; 
               const startDate = new Date(baslangicTarihi);
               for (let i = 0; i < taksit; i++) {
                   const odemeGunu = new Date(startDate);
                   odemeGunu.setMonth(startDate.getMonth() + i);
                   const newRef = doc(collection(db, collectionName));
                   const yeniKayit = {
                       cariId: cariData.id,
                       [isTedarikci ? 'firmaSahis' : 'cariAd']: adSoyad || firmaSahis,
                       [isTedarikci ? 'odemeTarihi' : 'odemeGunu']: odemeGunu,
                       miktar: aylikTutar, 
                       durum: 'Bekliyor'
                   };
                   batch.set(newRef, yeniKayit);
               }
           } else {
               const newRef = doc(collection(db, collectionName));
               const yeniKayit = {
                   cariId: cariData.id,
                   [isTedarikci ? 'firmaSahis' : 'cariAd']: adSoyad || firmaSahis,
                   [isTedarikci ? 'odemeTarihi' : 'odemeGunu']: new Date(baslangicTarihi),
                   miktar: borc,
                   durum: 'Bekliyor'
               };
               batch.set(newRef, yeniKayit);
           }
           logDetay += ` | Borç Yapılandırıldı: ${borc}₺`;
        }
      }

      await batch.commit();
      
      // LOG KAYDI
      logIslem("Düzenleme", logDetay, userEmail);

      setLoading(false);
      onClose();

    } catch (err) {
      console.error("Hata:", err);
      setError('Güncelleme başarısız: ' + err.message);
      setLoading(false);
    }
  };

  if (!cariData) return null; 

  return (
    <Modal
      show={show}
      onClose={onClose}
      title="Cari Kartı ve Borç Düzenleme"
      hideFooter={true}
      className="modal-content-wide" 
    >
      <form onSubmit={handleSave}>
        <div className="modal-grid-layout">
            <div className="left-column">
                <h3 className="modal-section-title">👤 Müşteri/Firma Bilgileri</h3>
                <div className="form-group">
                    <label>Firma / Ünvan</label>
                    <input type="text" value={firmaSahis} onChange={(e) => setFirmaSahis(e.target.value)} placeholder="Firma Adı" />
                </div>
                <div className="form-group">
                    <label>Adı Soyadı (Yetkili)</label>
                    <input type="text" value={adSoyad} onChange={(e) => setAdSoyad(e.target.value)} placeholder="Adı Soyadı" />
                </div>
                <div className="form-group">
                    <label>TC / Vergi No</label>
                    <input type="text" value={tc} onChange={(e) => setTc(e.target.value)} placeholder="TC Kimlik" />
                </div>
                <div className="form-group">
                    <label>Telefon</label>
                    <input type="text" value={telefon} onChange={(e) => setTelefon(e.target.value)} placeholder="05XX..." />
                </div>
                <div className="form-group">
                    <label>Adres / Not</label>
                    <textarea rows="3" value={adres} onChange={(e) => setAdres(e.target.value)}></textarea>
                </div>
            </div>

            <div className="right-column" style={{ borderLeft: '1px solid #eee', paddingLeft: '20px' }}>
                <h3 className="modal-section-title">💰 Finansal Yapılandırma</h3>
                <div style={{ marginBottom: '20px', padding: '15px', background: '#fff8e8', borderRadius: '8px', border: '1px solid #ffeeba' }}>
                    <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', color: '#d4af37', fontWeight: 'bold' }}>
                        <input type="checkbox" checked={yapilandir} onChange={(e) => setYapilandir(e.target.checked)} style={{ width: '20px', height: '20px', marginRight: '10px' }} />
                        Borcu / Ödeme Planını Güncelle
                    </label>
                    <p style={{ fontSize: '0.85rem', color: '#666', marginTop: '5px', marginLeft: '30px' }}>
                        Bunu işaretlerseniz, <b>eski tüm taksitler silinir</b> ve girdiğiniz yeni tutara göre <b>yeniden taksitlendirilir.</b>
                    </p>
                </div>
                {yapilandir && (
                    <div className="finans-inputs fade-in">
                        <div className="form-group">
                            <label>Yeni Toplam Borç (TL)</label>
                            <CurrencyInput value={yeniToplamBorc} onChange={setYeniToplamBorc} style={{ border: '2px solid #d4af37', fontWeight: 'bold', fontSize: '1.1rem' }} placeholder="0,00 ₺" />
                        </div>
                        <div className="form-group">
                            <label>Yeni Taksit Sayısı</label>
                            <select value={yeniTaksitSayisi} onChange={(e) => setYeniTaksitSayisi(e.target.value)}>
                                <option value="0">Tek Çekim / Peşin</option>
                                {[...Array(36)].map((_, i) => (<option key={i+1} value={i+1}>{i+1} Taksit</option>))}
                            </select>
                        </div>
                        <div className="form-group">
                            <label>İlk Ödeme Tarihi</label>
                            <input type="date" value={baslangicTarihi} onChange={(e) => setBaslangicTarihi(e.target.value)} />
                        </div>
                        {parseFloat(yeniToplamBorc) > 0 && parseInt(yeniTaksitSayisi) > 0 && (
                            <div style={{ marginTop: '10px', padding: '10px', background: '#e9ecef', borderRadius: '5px', textAlign: 'center' }}>
                                <strong>Aylık Ödeme: </strong> 
                                {(parseFloat(yeniToplamBorc) / parseInt(yeniTaksitSayisi)).toLocaleString('tr-TR', { style: 'currency', currency: 'TRY' })}
                            </div>
                        )}
                    </div>
                )}
            </div>
        </div>
        {error && <p className="login-error" style={{marginTop: '15px'}}>{error}</p>}
        <div className="modal-footer" style={{ borderTop: '2px solid #f0f0f0', marginTop: '20px', paddingBottom: '0' }}>
          <button type="button" onClick={onClose} className="admin-button-secondary">Vazgeç</button>
          <button type="submit" className="admin-button" disabled={loading} style={{ minWidth: '150px' }}>{loading ? 'İşleniyor...' : '💾 Tümünü Kaydet'}</button>
        </div>
      </form>
    </Modal>
  );
}
export default CariDuzenleModal;